import { UntitledIcon } from '@faceup/icons'
import { ulHome01 } from '@faceup/icons/ulHome01'
import { ulRefreshCw01 } from '@faceup/icons/ulRefreshCw01'
import { useRouteError } from '@faceup/router'
import { useComponentDidMount } from '@faceup/ui'
import { Button, Result } from '@faceup/ui-base'
import { NoShortIdError } from '../errors/NoShortIdError'
import { defineMessages, FormattedMessage } from '../TypedIntl'

const messages = defineMessages({
  description: 'FollowUp.RouteError.description',
  buttonBackHome: 'FollowUp.RouteError.buttonBackHome',
  buttonReload: 'FollowUp.RouteError.buttonReload',
})

export const RouterError = () => {
  const error = useRouteError()

  useComponentDidMount(() => {
    if (error instanceof NoShortIdError) {
      window.location.href = '/'
    }
  })

  return (
    <div className='flex flex-col items-center justify-center h-screen'>
      <Result
        status='500'
        title='500'
        subTitle={<FormattedMessage {...messages.description} />}
        extra={
          <div className='inline-flex flex-col gap-2'>
            <Button
              type='default'
              onClick={() => window.location.reload()}
              icon={<UntitledIcon icon={ulRefreshCw01} />}
            >
              <FormattedMessage {...messages.buttonReload} />
            </Button>

            <Button
              type='primary'
              onClick={() => (window.location.href = '/')}
              icon={<UntitledIcon icon={ulHome01} />}
            >
              <FormattedMessage {...messages.buttonBackHome} />
            </Button>
          </div>
        }
      />
    </div>
  )
}
